import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=14a61432"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports